import { mapActions, mapGetters, mapState } from 'vuex';
import { dateToString, toCents } from '@/utils/helpers';
import moment from 'moment';
import ls from '@/helpers/localStorage';
import { MODALS } from '@/components/app/app-modals/app-modals';

const DATE_FORMAT = 'MM/DD/YYYY hh:mm a';

export default {
  props: {
    scrollable: {
      type: Boolean,
      default: false,
    },
    minimumRows: {
      type: Number,
      default: 0,
    },
    contract: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
      default: [],
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    cardLayout: {
      type: Boolean,
      default: false,
    },
    compactCardLayout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAll: this.scrollable,
      showAllCut: 5,
    }
  },
  created() {
    this.updateShowAll();
  },
  watch: {
    'contract.contractId': {
      handler() {
        this.updateShowAll();
      },
    },
  },
  computed: {
    ...mapState('trade', ['tradeOptions']),
    ...mapGetters('user', ['isLoggedIn']),
    classModifiers() {
      return {
        'order-book-shares-sushi': true,
        'order-book-shares-sushi--card-layout': this.cardLayout,
        'order-book-shares-sushi--compact-card': this.cardLayout && this.compactCardLayout,
        'order-book-shares-sushi--card-empty': this.isCardEmpty,
        'order-book-shares-sushi--scrollable': this.scrollable,
        'order-book-shares-sushi--scrollable-empty': this.isScrollableEmpty,
      };
    },
    tableModifiers() {
      return {
        'order-book-sushi__table': true,
        'order-book-sushi__table--scrollable': this.scrollable,
      };
    },
    bodyModifiers() {
      return {
        'order-book-sushi__body': true,
        'order-book-sushi__body--scrollable': this.scrollable,
      };
    },
    showColumnHeader() {
      return this.scrollable;
    },
    showCardColumnHeader() {
      return this.cardLayout;
    },
    shares() {
      return this.items.map((s) => {
        return {
          ...s,
          pricePerShare: toCents(s.pricePerShare),
          dateExecuted: `${moment(s.dateExecuted).format(DATE_FORMAT)} ET`,
          isNo: (s.predictionType === 0 || s.predictionType === 2),
        };
      });
    },
    showAllItemsNotice() {
      if (this.scrollable) return false;
      return this.shares.length > this.showAllCut;
    },
    itemsToDisplay() {
      return this.showAll ? this.shares : this.shares.slice(0, this.showAllCut)
    },
    displayRows() {
      let minimumRows = Math.max(this.minimumRows, this.scrollable ? 0 : 1);
      if (this.cardLayout && this.compactCardLayout) {
        minimumRows = this.isCardEmpty ? 1 : 0;
      }
      const displayRows = [...this.itemsToDisplay];
      const rowCount = Math.max(displayRows.length, minimumRows);

      while (displayRows.length < rowCount) {
        displayRows.push(null);
      }

      return displayRows;
    },
    emptyStateText() {
      return this.isLoggedIn ? '(No Holdings)' : '(Not Logged In)';
    },
    isCardEmpty() {
      return this.cardLayout && this.shares.length === 0;
    },
    isScrollableEmpty() {
      return this.scrollable && this.shares.length === 0;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']),
    getDate(item) {
      const v = dateToString(item.dateExecuted).split(' ');
      return v[0];
    },
    loginClicked() {
      this.setCurrentPopup(MODALS.LOGIN);
    },
    onInfoClick(item) {
      this.setCurrentSmallPopup(MODALS.SMALL_SHARE_INFO);
      this.setCurrentPopupOptions({ item });
    },
    toggleShowAll() {
      this.showAll = !this.showAll;
      ls.set(`order_book_shares_show_all_${this.contract.contractId}`, this.showAll);
    },
    updateShowAll() {
      if (this.scrollable) return;
      this.showAll = ls.get(`order_book_shares_show_all_${this.contract.contractId}`, false);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/order-book-sushi/order-book-shares-sushi/order-book-shares-sushi.js